module.exports = __webpack_public_path__ + "static/media/Fidelius_Finalized_Logo_Parts-02.5a3d1f47.svg";